function AboutMetricsHistoricalScore(): JSX.Element {
  return (
    <div id="historicalScore">
      <h3>Historical Score</h3>
      <p>
        The DISGENET Historical Score recalculates the GDA DISGENET Score using only evidence available within
        a selected year or range of years. It applies a temporal filter across curated databases, literature,
        inferred data, clinical trials, and animal models. For curated sources, a source is counted only if its
        supporting publication falls within the selected period. The system also counts only publications
        available at that time and dynamically recomputes the final score.
      </p>
    </div>
  );
}

export default AboutMetricsHistoricalScore;
